module.exports = __webpack_public_path__ + "img/WeChat8303b184737b26729602b8b79feb6110.8303b184.png";